import React from 'react';
import logoSvg from '../assets/New_Ashley_logo_orange-white.png';

const Logo = ({ size = 'xlarge', className = '' }) => {
  const logoStyle = {
    width: 'auto',
    height: 'clamp(60px, 8vw, 80px)',
    maxWidth: '200px',
    display: 'inline-block',
    verticalAlign: 'middle'
  };

  return (
    <img 
      src={logoSvg} 
      alt="HPM Logo" 
      style={logoStyle}
      className={`hpm-logo ${className}`}
    />
  );
};

export default Logo;
